export var selectContent = function selectContent(state) {
  return state.content;
};

// Content
export var selectSystemProblemInternet = function selectSystemProblemInternet(state) {
  var _selectContent;
  return (_selectContent = selectContent(state)) === null || _selectContent === void 0 ? void 0 : _selectContent.SystemProblemInternet;
};
export var selectWelcomeText = function selectWelcomeText(state) {
  var _selectContent2;
  return (_selectContent2 = selectContent(state)) === null || _selectContent2 === void 0 || (_selectContent2 = _selectContent2.TextMainScreen) === null || _selectContent2 === void 0 ? void 0 : _selectContent2.content;
};
export var selectFrequentQuestions = function selectFrequentQuestions(state) {
  var _selectContent3;
  return ((_selectContent3 = selectContent(state)) === null || _selectContent3 === void 0 || (_selectContent3 = _selectContent3.FrequentQuestions) === null || _selectContent3 === void 0 ? void 0 : _selectContent3.content) || [];
};
export var selectIsHasFrequentQuestions = function selectIsHasFrequentQuestions(state) {
  var _selectFrequentQuesti;
  return !!((_selectFrequentQuesti = selectFrequentQuestions(state)) !== null && _selectFrequentQuesti !== void 0 && _selectFrequentQuesti.length);
};

// Quick Replies
export var selectQuickReplies = function selectQuickReplies(state) {
  return selectContent(state).quickReplies;
};
export var selectImageUrlGroup = function selectImageUrlGroup(state) {
  return selectContent(state).imageUrlGroup;
};
export var selectDynamicFormHeight = function selectDynamicFormHeight(state) {
  return selectContent(state).dynamicFormHeight;
};